module.exports = __webpack_public_path__ + "img/shenganlanlv.c3e0fb62.png";